module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }